import type { NativeEvent } from './types';

declare global {
  interface Window {
    nativeWebViewMessageHandler?: {
      postMessage: (message: string) => void;
    };
    webkit?: {
      messageHandlers?: {
        nativeWebViewMessageHandler?: {
          postMessage: (message: string) => void;
        };
      };
    };
  }
}

// Returns whether a bridge actually took the message, so a caller that suppresses its own
// fallback (e.g. a `tel:` anchor) can tell a real handoff from a no-op post.
const sendNativeEvent = (message: NativeEvent) => {
  let delivered = false;

  try {
    // Android
    if (typeof window.nativeWebViewMessageHandler?.postMessage === 'function') {
      window.nativeWebViewMessageHandler.postMessage(JSON.stringify(message));
      delivered = true;
    }

    // iOS
    if (
      typeof window.webkit?.messageHandlers?.nativeWebViewMessageHandler?.postMessage === 'function'
    ) {
      window.webkit.messageHandlers.nativeWebViewMessageHandler.postMessage(
        JSON.stringify(message)
      );
      delivered = true;
    }
  } catch {
    /* empty */
  }

  return delivered;
};

export default sendNativeEvent;
export type { NativeEvent, NativeEventSource } from './types';
